import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { changeVideoSpeed, changeVideoTime } from 'background/services'

import { generatePlayerId } from 'services/video'

const useStyles = makeStyles({
    video: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
    },
})

type Props = {
    playbookURL: string
    defaultSpeed?: number
    startTime?: number
}

export const VideoPlayer = ({
    playbookURL,
    defaultSpeed,
    startTime,
}: Props) => {
    const classes = useStyles()

    /* WARNING: In local or SDK build load a regular <video> since CSP is always ours. */
    if (process.env.NODE_ENV === 'development' || SDK_MODE) {
        return (
            <video
                controls
                autoPlay
                controlsList="nodownload"
                className={classes.video}
                src={playbookURL}
                id={generatePlayerId()}
                onLoadedMetadata={e => {
                    const player = e.target as HTMLVideoElement
                    if (!player) return

                    if (defaultSpeed && defaultSpeed > 1) {
                        player.playbackRate = defaultSpeed
                    }

                    if (startTime) {
                        player.currentTime = startTime
                    }
                }}
            />
        )
    }

    /* Iframe is used as a proxy to avoid CSP issues.
       When we try to load a video on a website, we download it under their CSP policies,
       often restricting unknown resources. Video will be blocked.
       That is why we load a video inside an iframe,
       then it is loaded under chrome extension CSP policy (our policy). */

    const source = `${window.chrome.extension.getURL(
        '/videoPlayer/player.html'
    )}?video=${encodeURIComponent(playbookURL)}`

    return (
        <iframe
            frameBorder={0}
            allow="autoplay; fullscreen"
            className={classes.video}
            title="Video Player"
            src={source}
            onLoad={() => {
                if (defaultSpeed && defaultSpeed > 1) {
                    changeVideoSpeed({ speed: defaultSpeed })
                }
                if (startTime) {
                    changeVideoTime({ seconds: startTime })
                }
            }}
        />
    )
}
